import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=0b3a3790&scoped=true"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a3790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3a3790')) {
      api.createRecord('0b3a3790', component.options)
    } else {
      api.reload('0b3a3790', component.options)
    }
    module.hot.accept("./RootView.vue?vue&type=template&id=0b3a3790&scoped=true", function () {
      api.rerender('0b3a3790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mcache/RootView.vue"
export default component.exports